import React from 'react';
import { flatten } from 'lodash';
import { StringUtil } from 'utils/StringUtil';
import apartmentIcon from 'assets/images/apartment.png';
import villaIcon from 'assets/images/villa.png';
import nearest from 'nearest-date';
import { DateUtil } from 'utils/DateUtil';
import moment from 'moment';

const mapRentalHomes = (rental, mediaPath) => {
  const rentalHomes = rental.home;
  const rentalCompletedHomes = rental.completedHome;
  const allRentals = rentalHomes.concat(rentalCompletedHomes);
  const sortedData = allRentals.sort(function(a, b) {
    return new Date(b.created) - new Date(a.created);
  });
  if (!rentalHomes || rentalHomes.length === 0) {
    return [];
  }

  return sortedData.map(event => mapRentalBrowser(event, mediaPath));
};

const mapRentalFeature = (rentalFeature, mediaPath) => {
  const allFeatures = rentalFeature && rentalFeature.features;
  if (!allFeatures || allFeatures.length === 0) {
    return [];
  }

  let features = [];
  allFeatures.map(data => {
    const featureData = {
      id: data.id,
      heading: data.heading,
      description: data.description,
      rental_home_id: data.rental_home_id,
      web: mediaPath.web,
      mobile: mediaPath.mobile,
      thumbnail: mediaPath.thumbnail,
    };
    features.push(featureData);
  });

  return features;
};

const mapRentalBrowser = (rental, mediaPath) => {
  const price = rental.rental_price.replace(',', '');
  const numberPrice = Number(price);
  const area = rental.area && rental.area.replace(',', '');
  const areaForFilter = Number(area);
  return [
    {
      name: StringUtil.checkBoolean(rental.is_completed_project)
        ? rental.completed_project.project_name
        : rental.project.project_details[0].project_name,
      project_image: `${mediaPath.web}/${rental.rental_image}`,
      mobile_image: `${mediaPath.mobile}/${rental.rental_mobile_image}`,
      thumbnailUrl: `${mediaPath.thumbnail}/${rental.image}`,
      id: rental.id,
      title: rental.title,
      price: rental.rental_price,
      priceForFilter: numberPrice,
      postFix: 'per month',
      rental_image: `${mediaPath.web}/${rental.rental_image}`,
      listMobileImageUrl: `${mediaPath.mobile}/${rental.rental_mobile_image}`,
      thumbnail: `${mediaPath.thumbnail}/${rental.rental_image}`,
      rental_home_url_slug: rental.rental_home_url_slug,
      bed: StringUtil.checkBoolean(rental.is_completed_project)
        ? rental.no_of_bedroom
        : rental.product.number_of_bedrooms,
      bath: StringUtil.checkBoolean(rental.is_completed_project)
        ? rental.no_of_bathroom
        : rental.product.number_of_bathrooms,
      city: StringUtil.checkBoolean(rental.is_completed_project)
        ? rental.completed_project.city.city_name
        : rental.project.city.city_name,
      latitude: !StringUtil.checkBoolean(rental.is_completed_project)
        ? rental.project.latitude
        : '',
      longitude: !StringUtil.checkBoolean(rental.is_completed_project)
        ? rental.project.longitude
        : '',
      location: StringUtil.checkBoolean(rental.is_completed_project)
        ? `${rental.completed_project.area &&
            rental.completed_project.area.area_name},${' '}${rental
            .completed_project.city && rental.completed_project.city.city_name}`
        : `${rental.project.area &&
            rental.project.area.area_name},${' '}${rental.project.city &&
            rental.project.city.city_name}`,
      cityId: StringUtil.checkBoolean(rental.is_completed_project)
        ? rental.completed_project.city_id
        : rental.project.city_id,
      countryName: StringUtil.checkBoolean(rental.is_completed_project)
        ? rental.completed_project.country.country_name
        : rental.project.country.country_name,
      propertyTypeId: !StringUtil.checkBoolean(rental.is_completed_project)
        ? rental.product.property_type_id
        : '',
      area: rental.area && rental.area,
      projectSlug: !StringUtil.checkBoolean(rental.is_completed_project)
        ? rental.project.url_slug
        : '',
      productSlug: !StringUtil.checkBoolean(rental.is_completed_project)
        ? rental.product.url_slug
        : '',
      isCompletedProject: StringUtil.checkBoolean(rental.is_completed_project),
      areaForFilter: areaForFilter,
    },
  ];
};

const mapRentalDetailBanner = (home, mediaPath) => {
  return { home: home.home, mediaPath };
};

const propertyTypeOptions = [
  { id: 1, title: 'Apartment', imageSource: apartmentIcon },
  { id: 2, title: 'Villa', imageSource: villaIcon },
];

const mapRentalFilters = response => {
  const rentals = mapRentalHomes(response, '');
  let rentalHomes = flatten(rentals);

  const locationsMap = {};
  rentalHomes.forEach(project => {
    const country = project.countryName;
    if (!locationsMap[country]) {
      locationsMap[country] = [];
    }
    const cityId = project.cityId;
    const city = project.city;

    if (locationsMap[country].findIndex(item => item.id === cityId) === -1) {
      locationsMap[country].push({ id: cityId, name: city });
    }
  });

  const locations = Object.keys(locationsMap).map(country => {
    return {
      country,
      cities: locationsMap[country],
    };
  });

  return {
    location: locations,
    propertyType: [...propertyTypeOptions],
    range: {
      min: 25000,
      max: 60000,
    },
    area: {
      min: 1200,
      max: 5000,
    },
    beds: {
      min: 1,
      max: 5,
    },
  };
};

const mapAdvertisementSection = (data, mediaPath) => {
  const rentals = [data.home, data.completedHome];
  const rentalHomes = flatten(rentals);
  if (!rentalHomes || rentalHomes.length === 0) {
    return [];
  }

  const today = moment().format('YYYY-MM-DD');
  let created_at_dates = rentalHomes.map(list => {
    let full_date = DateUtil.getFullDateString(list.created);
    full_date = new Date(full_date);
    return full_date;
  });
  const index = nearest(created_at_dates, new Date(today));
  const nearest_date = DateUtil.getFullDateString(created_at_dates[index]);

  let homes = rentalHomes.map(list => {
    if (DateUtil.getFullDateString(list.created) === nearest_date) {
      return list;
    }
  });

  homes = homes.filter(element => {
    return element !== undefined;
  });

  return { homes: homes[0], mediaPath, rentalHomes };
};

export const RentalMapper = {
  mapRentalHomes,
  mapRentalFilters,
  mapRentalDetailBanner,
  mapRentalFeature,
  mapAdvertisementSection,
};
